/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/reasonCodeOperationModal/reasonCodeOperationModalBase"/>
import { LocalizationContext } from "@medius/ui-controls";
import { mapFromNorthstarToApa } from "Core/Medius.Core.Web/Scripts/lib/northstarLocalization";
import { getCultureCode } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import * as React from "react";
import { ReasonCodeOperationModal } from "./reasonCodeOperationModal";
import { ReasonCodeOperationType } from "../shared/interfaces";
import { EntityType } from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/interfaces";

export interface ReasonCodeOperationModalBaseProps {
    documentId: number;
    show: boolean;
    onClose: (wasConfirmed: true) => void
    hierarchyId: string;
    modalType: ReasonCodeOperationType;
    task: string;
    entityType: EntityType;
    currentDocumentType: string;
}

export const ReasonCodeOperationModalBase: React.FC<ReasonCodeOperationModalBaseProps> = ({ show, ...otherProps }) => {
    if (!show) return null;
    return (
        <LocalizationContext.Provider value={{
                translate: (key: string, defaultValue?: string) => mapFromNorthstarToApa(key, defaultValue),
                getLocale: () => getCultureCode()
            }}>
                <ReasonCodeOperationModal 
                    {...otherProps}
                />
        </LocalizationContext.Provider>
    );
};